import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SegmentedControl } from '@feathr/components';

export type TProjectStatus = 'active' | 'hidden';

interface IProjectStatusSegmentedControlProps {
  value: TProjectStatus;
  onChange: (status: TProjectStatus) => void;
  activeCount?: number;
  hiddenCount?: number;
  fullWidth?: boolean;
}

function ProjectStatusSegmentedControl({
  value,
  onChange,
  activeCount,
  hiddenCount,
  fullWidth = true,
}: Readonly<IProjectStatusSegmentedControlProps>): JSX.Element {
  const { t } = useTranslation();

  function handleChange(newValue: string): void {
    onChange(newValue as TProjectStatus);
  }

  const data = [
    {
      label: t('Active'),
      value: 'active',
      count: activeCount ?? 0,
    },
    {
      label: t('Hidden'),
      value: 'hidden',
      count: hiddenCount ?? 0,
    },
  ];

  return (
    <SegmentedControl
      data={data}
      fullWidth={fullWidth}
      name={'project-status-segmented-control'}
      onChange={handleChange}
      value={value}
    />
  );
}

export default ProjectStatusSegmentedControl;
